import React, { useCallback } from 'react'

import type { AdapterKitControlProps } from 'components/formKit/types'
import type { PhoneInputProps } from 'components/uiKit.todo/PhoneInput'
import PhoneInput from 'components/uiKit.todo/PhoneInput'
import { isMixed } from 'components/uiKit/KitUtils'

const FieldPhone = ({
  name,
  onChange,
  defaultValue,
  value,
  ...restProps
  // @ts-expect-error TODO PhoneInputProps
}: AdapterKitControlProps<PhoneInputProps, PhoneInputProps['value']>) => {
  const safeValue = isMixed(value) ? undefined : (value as PhoneInputProps['value'])
  const safeDefault = isMixed(defaultValue) ? undefined : (defaultValue as PhoneInputProps['value'])
  const onChangeWrapper = useCallback(
    (value: PhoneInputProps['value']) => onChange({ name, value }),
    [name, onChange],
  )
  return (
    <PhoneInput
      {...restProps}
      name={name}
      onChange={onChangeWrapper}
      value={safeValue ?? safeDefault}
    />
  )
}

export default React.memo(FieldPhone) as typeof FieldPhone
